<script>
import Cookies from 'js-cookie'
import commonMixin from './mixin'

export default {
    mixins: [commonMixin],
    watch: {
        async current(val, oldVal) {
            const { workspaceId, appId } = this.$route.params
            if (val && val.workspaceId && workspaceId &&  oldVal.workspaceId && oldVal && val.workspaceId !== workspaceId) {
                const { name } = this.$route
                this.$router.replace({
                    name,
                    params: {
                        appId,
                        workspaceId: val.workspaceId,
                    },
                })
                await this.$store.dispatch('REFRESH_TOKEN', { workspaceId: val.workspaceId, workspaceName: val.workspaceName })
                this.$nextTick(this.resetApp)
            }
        },
    },

    methods: {
        async initApp() {
            const {
                appId, /*code: appCode, businessEnvId: envId, fromAppId, fromEnvId,*/ isTenant,
            } = this.$store.state.modeling.app
            await this.$store.dispatch('GET_APP_SETTING')

            // const params = (isTenant && fromAppId) ? {
            //     appId, appCode, envId, fromAppId, fromEnvId,
            // } : {
            //     appId, appCode, envId, fromEnvId,
            // }
            // await this.$store.dispatch('INIT_APP', params)

            if (isTenant) {
                await this.$store.dispatch('GET_VALID_PURVIEW', {
                    appId,
                })
            }

            this.cacheCookies(Cookies.get())
        },
        resetApp() {
            window.location.reload()
        },
        async updateAppInfo(options) {
            const { workspaceId, appId: cAppId } = this.$route.params
            await this.$store.dispatch('GET_APP_DETAIL', { workspaceId, appId: cAppId })

            const {
                appId, /*code: appCode, businessEnvId: envId, fromAppId, fromEnvId, */ isTenant,
            } = this.$store.state.modeling.app

            if (isTenant) {
                await this.$store.dispatch('GET_VALID_PURVIEW', { appId })
            }

            // await this.$store.dispatch('GET_APP_SETTING')

            // const params = (isTenant && fromAppId) ? {
            //     appId, appCode, envId, fromAppId, fromEnvId,
            // } : {
            //     appId, appCode, envId, fromEnvId,
            // }
            // this.$store.dispatch('GET_CONF_LIST', params)

            if (options?.envId) {
                this.$store.dispatch('GET_BUSINESS_ENV_DETAIL', { appId: options.appId, envId: options.envId })
            }
        },
    },
}
</script>

<style lang="less">
@import url('./index.less');
</style>
